import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ScreenSizeService } from '../../../services/screen-size.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent {

  renderDashboardTitle: boolean = false;
  isMobile: boolean = false;
  hideHeader: boolean = false;

  constructor(
    private router: Router,
    private screenSizeService: ScreenSizeService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.setTitleBasedOnRoute();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setTitleBasedOnRoute();
    });

    this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  setTitleBasedOnRoute() {
    const childRoute = this.activatedRoute.firstChild;

    if (childRoute) {
      const path = childRoute.snapshot.url[0]?.path;
      const data = childRoute.snapshot.data;
      
      this.hideHeader = data?.['hideHeader'] || false;
      
      if (path === 'market') {
        this.renderDashboardTitle = true;
      } else {
        this.renderDashboardTitle = false;
      }
    } else {
      const currentUrl = this.router.url.split('/').pop();
      if (currentUrl === 'market') {
        this.renderDashboardTitle = true;
      } else {
        this.renderDashboardTitle = false;
      }
      this.hideHeader = false;
    }
  }
}
